import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const StoreContext = createContext();

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
};

export const StoreProvider = ({ children }) => {
  const [storeConfig, setStoreConfig] = useState({
    store_name: '優爾商城',
    store_name_short: '優爾',
    store_name_en: 'YourMall',
    company_name: '',
    phone: '',
    email: '',
    line_id: '',
    service_hours: '',
    logo_url: '/images/logo.svg',
    favicon_url: '/favicon.ico',
    og_image_url: '',
    description: '',
    slogan: '批發優惠價，超商取貨',
    stats_inventory: '多樣',
    stats_delivery: '2-3天',
    facebook_url: '',
    instagram_url: '',
    line_url: ''
  });

  const [seoConfig, setSeoConfig] = useState({
    site_name: '優爾商城',
    site_url: '',
    default_title: '優爾商城 | 批發優惠價 滿799免運',
    default_description: '',
    default_keywords: '',
    google_verification: '',
    bing_verification: ''
  });

  const [features, setFeatures] = useState([]);
  const [categories, setCategories] = useState([]);
  const [shippingConfig, setShippingConfig] = useState({
    base_fee: 60,
    free_shipping_threshold: 799
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPublicSettings();
  }, []);

  const loadPublicSettings = async () => {
    try {
      const [storeRes, seoRes, featuresRes, categoriesRes, shippingRes] = await Promise.all([
        api.get('/settings/store/public'),
        api.get('/settings/seo/public'),
        api.get('/settings/features/public'),
        api.get('/settings/categories/public'),
        api.get('/settings/shipping/public')
      ]);

      if (storeRes.data.success) {
        setStoreConfig(prev => ({ ...prev, ...storeRes.data.config }));
      }
      if (seoRes.data.success) {
        setSeoConfig(prev => ({ ...prev, ...seoRes.data.config }));
      }
      if (featuresRes.data.success) {
        setFeatures(featuresRes.data.features || []);
      }
      if (categoriesRes.data.success) {
        setCategories(categoriesRes.data.categories || []);
      }
      if (shippingRes.data.success && shippingRes.data.config) {
        setShippingConfig({
          base_fee: parseInt(shippingRes.data.config.base_fee) || 60,
          free_shipping_threshold: parseInt(shippingRes.data.config.free_shipping_threshold) || 799
        });
      }
    } catch (error) {
      console.error('載入商店設定失敗:', error);
    } finally {
      setLoading(false);
    }
  };

  const value = {
    storeConfig,
    seoConfig,
    features,
    categories,
    shippingConfig,
    loading,
    refreshSettings: loadPublicSettings
  };

  return (
    <StoreContext.Provider value={value}>
      {children}
    </StoreContext.Provider>
  );
};

export default StoreContext;
